module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/point_maedori_03@3x-9b808329aecedb0b35a822bfb4901c77.webp";